<section
  class="features"
  *ngIf="features.length > 0"
>

  <article
    class="feature-card"
    *ngFor="let feature of features"
  >

    <div class="icon">
      {{ feature.icon }}
    </div>


    <div class="feature-content">

      <h3>
        {{ feature.title }}
      </h3>

      <p>
        {{ feature.description }}
      </p>

    </div>

  </article>

</section>